export default {"src":"__ASTRO_ASSET_IMAGE__CbPB9Lnw__","width":260,"height":324,"format":"gif"}